import ApiConnector from '@/models/ApiConnector';
import ApiModel     from '@widesk-core/models/ApiModel';
import config       from '@/config';

export const notificationConnector = new ApiConnector({
	baseURL: config.api_endpoint + `/notification`,
});

export default class NotificationServiceModel extends ApiModel {
	public static get connector() {
		return notificationConnector;
	}

	public static serviceName = 'notification';
	public static partitionName = 'jts';
}